import { render, staticRenderFns } from "./sop-test.vue?vue&type=template&id=a68044ac"
import script from "./sop-test.vue?vue&type=script&lang=js"
export * from "./sop-test.vue?vue&type=script&lang=js"
import style0 from "./sop-test.vue?vue&type=style&index=0&id=a68044ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports